"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withJimuComponentAdaptor = exports.JimuAdaptor = exports.IJimuAdaptor = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _gemsShared = require("@tencent/gems-shared");

var _lodash = _interopRequireDefault(require("lodash.template"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

class IJimuAdaptor extends React.PureComponent {
  constructor(_props) {
    super(_props);
    (0, _defineProperty2.default)(this, "jimuInstance", void 0);
    (0, _defineProperty2.default)(this, "jimuTemplate", void 0);
    (0, _defineProperty2.default)(this, "hasInited", false);
    (0, _defineProperty2.default)(this, "node", null);
    (0, _defineProperty2.default)(this, "setNode", node => {
      if (!node) {
        return;
      }

      this.node = node;

      if (!this.hasInited) {
        this.renderComponent(this.node, this.props.instance);
      }
    });
    (0, _defineProperty2.default)(this, "renderComponent", (node, instance) => {
      const key = instance.key,
            style = instance.style,
            data = instance.data,
            commonStyle = instance.commonStyle;

      const props = _objectSpread(_objectSpread({
        id: `jimu-adaptor-${key}`
      }, data), {}, {
        it: data,
        style,
        commonStyle
      });

      const externalProps = {
        global: this.props.global,
        meta: this.props.meta,
        style,
        commonStyle,
        componentsMap: _gemsShared.componentNodeMap,
        getComponentByKey: _gemsShared.getComponentNode
      };
      const updateTemplate = style !== this.props.instance.style || commonStyle !== this.props.instance.commonStyle;

      if (updateTemplate || !this.hasInited) {
        try {
          node.innerHTML = this.jimuTemplate(props);
          this.jimuInstance = new this.props.View();
          this.jimuInstance.init(props, externalProps);
        } catch (e) {
          console.error(e);
        }

        this.hasInited = true;
      } else {
        this.jimuInstance.refreshData(props, externalProps);
      }
    });
    const _instance = _props.instance,
          View = _props.View;
    this.jimuTemplate = _instance.component.template;
    this.jimuInstance = new View();
  }

  UNSAFE_componentWillReceiveProps({
    instance: nextInstance
  }) {
    if (!this.node) {
      return;
    }

    this.renderComponent(this.node, nextInstance);
  }

  render() {
    return /*#__PURE__*/React.createElement("div", {
      ref: this.setNode
    });
  }

}

exports.IJimuAdaptor = IJimuAdaptor;
const JimuAdaptor = /*#__PURE__*/React.memo(IJimuAdaptor);
exports.JimuAdaptor = JimuAdaptor;

const withJimuComponentAdaptor = View => {
  function WithComponentAdaptor(props) {
    const instance = props.instance,
          injectProps = props.injectProps,
          global = props.global,
          meta = props.meta,
          hotAreas = props.hotAreas,
          children = props.children,
          emit = props.emit,
          on = props.on,
          off = props.off;

    if (instance.component.runtime !== 'jimu') {
      return /*#__PURE__*/React.createElement(View, props);
    }

    console.log('jimu adaptor work');
    const _instance$component$c = instance.component.component,
          Component = _instance$component$c.component,
          t = _instance$component$c.template;

    const finalInstance = _objectSpread(_objectSpread({}, instance), {}, {
      component: {
        template: (0, _lodash.default)(`${t}`)
      }
    });

    return /*#__PURE__*/React.createElement(JimuAdaptor, {
      View: Component,
      instance: finalInstance,
      injectProps: injectProps,
      global: global,
      meta: meta,
      hotAreas: hotAreas,
      emit: emit,
      on: on,
      off: off
    }, children);
  }

  return /*#__PURE__*/React.memo(WithComponentAdaptor);
};

exports.withJimuComponentAdaptor = withJimuComponentAdaptor;